import { Model, hasMany, belongsTo } from 'miragejs';

export default Model.extend({
  deviceConfigStaticPage: belongsTo('device-config-static-page'),
  deviceConfigStaticPageAttributeTranslations: hasMany('device-config-static-page-attribute-translation'),
});
